import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Typography, Box } from "@mui/material"

import useAppStore from "store/app"
import useAlertStore from "store/alert"

import { diagnosticToBoolean } from "config/helpers"

import Layout from "./Layout"
import Gender from "../../shared/fields/Gender"
import Weight from "../../shared/fields/Weight"
import Height from "../../shared/fields/Height"
import SecondaryButton from "../../shared/buttons/SecondaryButton"
import Diabets from "../../shared/fields/check/Diabets"
import SufferedAnInjury from "../../shared/fields/check/SufferedAnInjury"
import HighCholesterol from "../../shared/fields/check/HighCholesterol"
import Hypertension from "../../shared/fields/check/Hypertension"
import useTranslation from "../../../hooks/use_translation"

const PersonalDataPhysiological = () => {
  const fields = useAppStore((state) => state.fields)
  const resetFields = useAppStore((state) => state.resetFields)
  const updateFieldErrorMessage = useAppStore((state) => state.updateFieldErrorMessage)
  const updateClientInfo = useAppStore((state) => state.updateClientInfo)
  const syncClient = useAppStore((state) => state.syncClient)
  const showAlert = useAlertStore((state) => state.showAlert)

  const t = useTranslation()

  const navigate = useNavigate()

  useEffect(() => {
    resetFields()
  }, [])

  const handleSubmit = (event) => {
    event.preventDefault()

    let valid = true

    const errorsCheck = [
      "gender",
      "weight",
      "height",
      "cholesterol",
      "hypertension",
      "injury",
      "diabetes",
    ]

    errorsCheck.map((field) => {
      if (!fields[field]?.touched) {
        valid = false
        updateFieldErrorMessage(field, t?.fields?.required)
      }

      if (fields[field].error_message !== "") {
        valid = false
      }
    })

    if (!valid) return

    const params = {
      gender: fields.gender?.input_value,
      weight: parseInt(fields.weight?.input_value),
      height: parseInt(fields.height?.input_value),
      cholesterol: diagnosticToBoolean(fields.cholesterol?.input_value),
      hypertension: diagnosticToBoolean(fields.hypertension?.input_value),
      injury: diagnosticToBoolean(fields.injury?.input_value),
      diabetes: diagnosticToBoolean(fields.diabetes?.input_value),
    }

    updateClientInfo(params)
      .then((response) => {
        syncClient(response.data)
        showAlert(t?.messages?.success_update_user_info, "success")

        navigate("/me")
      })
      .catch((error) => showAlert(error.message, "error"))
  }

  return (
    <Layout>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
        {t?.pages?.personal_data?.physiological_title}
      </Typography>

      <Typography variant="body1" sx={{ fontWeight: 500, mb: 1 }}>
        {t?.pages?.personal_data?.physiological_subtitle}
      </Typography>

      <Gender />
      <Weight />
      <Height />
      <Box sx={{ mb: 4 }} />
      <SufferedAnInjury />
      <HighCholesterol />
      <Hypertension />
      <Diabets />

      <SecondaryButton
        fullWidth
        text={t?.pages?.personal_data?.physiological_submit_btn}
        onClick={handleSubmit}
      />
    </Layout>
  )
}

export default PersonalDataPhysiological
